import React from 'react';

const QuizPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Quiz</h1>
      <div className="bg-white p-6 rounded-lg shadow">
        <p className="text-gray-600">Quiz page - To be implemented</p>
      </div>
    </div>
  );
};

export default QuizPage; 